export default __webpack_public_path__ + "static/media/img_05.a12c6a7c.jpg";